import {
  KeyframeViewer,
  useSelectedViewer,
} from "lib/contexts/ProjectContexts/SelectedViewerContext";
import { useViewsMode } from "lib/contexts/SpatialContexts/ViewsModeContext";
import { useCesium } from "components/elements/CesiumViewer/core/useCesium";
import { useSyncCesium } from "components/elements/CesiumViewer/core/useSyncCesium";

/**
 * The viewer actually on screen. A selected panorama takes over from the
 * selected viewer, and an open view's Snapshot tab replaces Cesium while
 * leaving it selected underneath.
 */
export function useVisibleViewer() {
  const viewerControls = useSelectedViewer();
  const { scansetPlugin } = useCesium();
  const selectedScan = useSyncCesium(scansetPlugin.selectedScan);
  const { loadedView, activeTab } = useViewsMode();

  const viewer = selectedScan
    ? KeyframeViewer.Pannellum
    : viewerControls?.viewer ?? KeyframeViewer.Cesium;
  const isViewSnapshotShowing =
    viewer === KeyframeViewer.Cesium &&
    !!loadedView &&
    activeTab === "snapshot";

  return {
    viewer,
    isViewSnapshotShowing,
    isCesiumShowing: viewer === KeyframeViewer.Cesium && !isViewSnapshotShowing,
  };
}
